(function () {
  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function buildReference(date) {
    return [
      'WID',
      date.getFullYear(),
      pad(date.getMonth() + 1),
      pad(date.getDate()),
      '-',
      pad(date.getHours()),
      pad(date.getMinutes()),
      pad(date.getSeconds())
    ].join('');
  }

  function formatDateTime(date) {
    return new Intl.DateTimeFormat('de-DE', {
      dateStyle: 'medium',
      timeStyle: 'short'
    }).format(date);
  }

  function getValue(form, selector) {
    var field = form.querySelector(selector);
    return field ? field.value.trim() : '';
  }

  function setText(root, selector, value) {
    var target = root.querySelector(selector);
    if (target) target.textContent = value || '-';
  }

  function initWithdrawalFlow(scope) {
    var forms = scope.querySelectorAll('.withdrawal-flow__form');

    forms.forEach(function (form) {
      if (form.dataset.withdrawalBound === 'true') return;
      form.dataset.withdrawalBound = 'true';

      var section = form.closest('[data-withdrawal-section]');
      if (!section) return;

      var panels = section.querySelectorAll('[data-step-panel]');
      var steps = section.querySelectorAll('[data-withdrawal-step]');
      var nextButton = section.querySelector('[data-withdrawal-next]');
      var backButton = section.querySelector('[data-withdrawal-back]');
      var specificItemsWrap = section.querySelector('[data-specific-items-wrap]');
      var specificItemsField = section.querySelector('[data-specific-items]');
      var reviewPanel = section.querySelector('[data-step-panel="2"]');
      var referenceField = section.querySelector('[data-reference-field]');
      var timestampField = section.querySelector('[data-timestamp-field]');
      var declarationField = section.querySelector('[data-declaration-field]');
      var bodyField = section.querySelector('[data-body-field]');

      function selectedScope() {
        var checked = form.querySelector('input[name="Umfang_des_Widerrufs"]:checked');
        return checked ? checked.value : '';
      }

      function syncSpecificItems() {
        var isSpecific = selectedScope() === 'Nur bestimmte Artikel aus der Bestellung';
        if (specificItemsWrap) specificItemsWrap.hidden = !isSpecific;
        if (specificItemsField) {
          specificItemsField.required = isSpecific;
          if (!isSpecific) specificItemsField.setCustomValidity('');
        }
      }

      function setStep(step) {
        panels.forEach(function (panel) {
          panel.hidden = panel.dataset.stepPanel !== String(step);
        });

        steps.forEach(function (item) {
          var isActive = item.dataset.withdrawalStep === String(step);
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-current', isActive ? 'step' : 'false');
        });

        form.dataset.currentStep = String(step);
      }

      function validateStepOne() {
        syncSpecificItems();
        var stepOne = section.querySelector('[data-step-panel="1"]');
        if (!stepOne) return true;

        var controls = Array.prototype.slice.call(
          stepOne.querySelectorAll('input, select, textarea')
        ).filter(function (control) {
          return !control.disabled && control.offsetParent !== null;
        });

        for (var i = 0; i < controls.length; i += 1) {
          if (!controls[i].checkValidity()) {
            controls[i].reportValidity();
            return false;
          }
        }

        return true;
      }

      function ensureReference() {
        var now = new Date();
        if (referenceField && !referenceField.value) {
          referenceField.value = buildReference(now);
        }
        if (timestampField) {
          timestampField.value = formatDateTime(now);
        }
      }

      function updateReview() {
        ensureReference();

        var name = getValue(form, '[name="Vor_und_Nachname"]');
        var email = getValue(form, '[name="email"]');
        var order = getValue(form, '[name="Bestellnummer_oder_Vertragsnummer"]');
        var scopeValue = selectedScope();
        var items = scopeValue === 'Nur bestimmte Artikel aus der Bestellung'
          ? getValue(form, '[name="Bestimmte_Artikel"]')
          : 'Nicht erforderlich';
        var hygiene = getValue(form, '[name="Hygienesiegelung"]') || 'Nicht angegeben';
        var reference = referenceField ? referenceField.value : '';
        var timestamp = timestampField ? timestampField.value : '';
        var declaration = 'Hiermit widerrufe ich den Vertrag ueber die oben angegebene Bestellung bzw. die oben angegebenen Artikel.';

        setText(section, '[data-summary="name"]', name);
        setText(section, '[data-summary="email"]', email);
        setText(section, '[data-summary="order"]', order);
        setText(section, '[data-summary="scope"]', scopeValue);
        setText(section, '[data-summary="items"]', items);
        setText(section, '[data-summary="hygiene"]', hygiene);
        setText(section, '[data-summary="reference"]', reference);
        setText(section, '[data-summary="timestamp"]', timestamp);
        setText(section, '[data-success-reference]', reference);
        setText(section, '[data-success-timestamp]', timestamp);

        if (declarationField) declarationField.value = declaration;
        if (bodyField) {
          bodyField.value = [
            'Formular: Vertrag widerrufen',
            'Referenznummer: ' + reference,
            'Eingangszeitpunkt: ' + timestamp,
            'Vor- und Nachname: ' + name,
            'E-Mail-Adresse: ' + email,
            'Bestellnummer oder Vertragsnummer: ' + order,
            'Umfang des Widerrufs: ' + scopeValue,
            'Bestimmte Artikel: ' + items,
            'Hygienesiegelung: ' + hygiene,
            '',
            'Widerrufserklaerung:',
            declaration
          ].join('\n');
        }
      }

      form.querySelectorAll('input[name="Umfang_des_Widerrufs"]').forEach(function (input) {
        input.addEventListener('change', syncSpecificItems);
      });

      if (nextButton) {
        nextButton.addEventListener('click', function () {
          if (!validateStepOne()) return;
          updateReview();
          setStep(2);
          if (reviewPanel) reviewPanel.focus({ preventScroll: false });
        });
      }

      if (backButton) {
        backButton.addEventListener('click', function () {
          setStep(1);
        });
      }

      form.addEventListener('submit', function (event) {
        if (form.dataset.currentStep !== '2') {
          event.preventDefault();
          if (nextButton) nextButton.click();
          return;
        }

        if (!validateStepOne()) {
          event.preventDefault();
          setStep(1);
          return;
        }

        updateReview();
      }, true);

      syncSpecificItems();
      setStep(1);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initWithdrawalFlow(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initWithdrawalFlow(event.target);
  });
})();
